<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  evidence: readonly { label: string; value: string }[]
}>()

// The server caps evidence at 50 rows per finding; this mirrors that cap so a
// misbehaving server can never make the table grow without bound.
const MAX_ROWS = 50

const visible = computed(() => props.evidence.slice(0, MAX_ROWS))
const hiddenCount = computed(() => Math.max(props.evidence.length - MAX_ROWS, 0))
</script>

<template>
  <div
    v-if="props.evidence.length > 0"
    class="overflow-x-auto"
  >
    <table class="w-full text-left text-sm">
      <caption class="sr-only">
        Evidence
      </caption>
      <thead>
        <tr>
          <th
            scope="col"
            class="eyebrow"
          >
            Field
          </th>
          <th
            scope="col"
            class="eyebrow"
          >
            Value
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in visible"
          :key="index"
        >
          <td class="eyebrow">
            {{ row.label }}
          </td>
          <td class="quoted break-words whitespace-pre-wrap">
            {{ row.value }}
          </td>
        </tr>
        <tr v-if="hiddenCount > 0">
          <td
            colspan="2"
            class="text-ink-muted"
          >
            {{ hiddenCount }} more not shown
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
